import { useEffect, useState } from "react";
import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import SuggestionPopup from "./suggestionPopup";

const ShowTestUnattempted = () => {
  const nav = useNavigate();
  const store = useSelector((state) => state);
  const location = useLocation();

  const questionsList =
    location.state?.viewTest || location.state?.testStoreQuestionList;

  const suggestionList = questionsList || [];

  const [questionsListData, setQuestionsListData] = useState({
    mcq: [],
    short_answer: [],
    fill_in_the_blank: [],
  });

  const [openPopup, setOpenPopup] = useState(false);

  const convertToGroupedFormat = (evaluatedArray) => {
    const grouped = {
      mcq: [],
      short_answer: [],
      fill_in_the_blank: [],
    };

    evaluatedArray?.forEach((item) => {
      const formattedItem = {
        question: item?.question,
        correct_answer: item?.correct_answer,
        user_answer: item?.user_answer,
        explanation: item?.explanation,
        marks_awarded: item?.marks_awarded,
        max_marks: item?.max_marks,
        evaluation: item?.evaluation || "",
        topic: item?.topic || "",
        question_type: item?.question_type,
        options: item?.options,
      };

      if (item?.question_type === "mcq") grouped?.mcq.push(formattedItem);
      else if (item?.question_type === "short_answer")
        grouped?.short_answer.push(formattedItem);
      else if (item?.question_type === "fill_in_the_blank")
        grouped.fill_in_the_blank.push(formattedItem);
    });

    return grouped;
  };

  const { responseFromResult } = useSelector((state) => state.TestManager);

  useEffect(() => {
    if (questionsList?.assignment_data) {
      const {
        mcq = [],
        short_answer = [],
        fill_in_the_blank = [],
      } = questionsList.assignment_data;

      const normalize = (item) => ({
        question: item?.question,
        correct_answer: item?.correct_answer,
        user_answer: item?.user_answer,
        explanation: item?.explanation,
        marks_awarded: item?.marks_awarded,
        max_marks: item?.max_marks,
        evaluation: item?.evaluation || "",
        topic: item?.topic || "",
        question_type: item?.question_type,
        options: item?.options,
      });

      setQuestionsListData({
        mcq: mcq.map(normalize),
        short_answer: short_answer.map(normalize),
        fill_in_the_blank: fill_in_the_blank.map(normalize),
      });
    } else {
      const grouped = convertToGroupedFormat(
        responseFromResult?.detailed_evaluation,
      );
      setQuestionsListData(grouped);
    }
  }, [questionsList]);

  const mcqCount = questionsListData?.mcq?.length || 0;
  const shortAnswerCount = questionsListData?.short_answer?.length || 0;

  //   const renderResultBox = (q) => {
  //     const isCorrect = q?.evaluation === "correct";

  //     return (
  //       <div
  //         style={{
  //           marginTop: "10px",
  //           padding: "10px 14px",
  //           borderRadius: "6px",
  //           background: "#f8f9fa",
  //           border: "1px solid #e3e3e3",
  //           fontSize: "15px",
  //         }}
  //       >
  //         <div>
  //           <strong>Marks Secured:</strong> {q?.marks_awarded}
  //         </div>

  //         <div
  //           style={{
  //             color: isCorrect ? "#1c8c3a" : "#d93025",
  //             fontWeight: "600",
  //           }}
  //         >
  //           Result: {isCorrect ? "Correct ✅" : "Incorrect ❌"}
  //         </div>

  //         {q?.explanation && (
  //           <div style={{ marginTop: "5px" }}>
  //             <strong>Explanation:</strong> {q.explanation}
  //           </div>
  //         )}
  //       </div>
  //     );
  //   };

  return (
    <main className="ff2 main-page">
      <HeaderBar />

      <div className="overflow-hidden inner-page-content inner-page-content--test">
        <SideBar />

        <div className="w-100 all-ans">
          <div className="mb-3">
            <img
              src="/assets/images/box-arrow-left.svg"
              className="pointer-cursor"
              alt="Back"
              style={{ cursor: "pointer" }}
              onClick={() => nav("/test")}
              width="25"
              height="25"
            />
          </div>

          <div className="all-ans__header">
            <h1 className="fw900 all-ans__header--title">Correct Answers:</h1>
          </div>

          <div className="all-ans__content">
            {/* MCQ */}
            {questionsListData?.mcq?.map((q, idx) => {
              return (
                <div key={`mcq-${idx}`} className="all-ans__content--item">
                  <h2
                    className="fz20 fw700"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div className="num">{idx + 1}.</div>
                      <div className="ques">{q.question}</div>
                    </div>

                    {/* <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        background: "#f1f5f9",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        color: "#334155",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {q?.max_marks} Marks
                    </div> */}
                  </h2>

                  <ul
                    className="list-inline option-list"
                    style={{ paddingLeft: "20px" }}
                  >
                    {q?.options?.map((opt, optIdx) => {
                      const isCorrect = opt === q?.correct_answer;
                      const isUserSelected = opt === q?.user_answer;

                      let optionClass = "fz20 fw500 option";
                      let inlineStyle = {};

                      if (isCorrect && isCorrect === isUserSelected)
                        optionClass += " option--correct";

                      if (isUserSelected && !isCorrect) {
                        inlineStyle = {
                          border: "1px solid red",
                          background: "#f9f9f9",
                        };
                      }

                      return (
                        <li key={optIdx}>
                          <div className={optionClass} style={inlineStyle}>
                            <div className="option__text">{opt}</div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>

                  {/* {renderResultBox(q)} */}
                </div>
              );
            })}

            {/* Short Answer */}
            {questionsListData?.short_answer?.map((q, idx) => {
              const baseIndex = mcqCount + idx;

              return (
                <div key={`short-${idx}`} className="all-ans__content--item">
                  <h2
                    className="fz20 fw700"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div className="num">{baseIndex + 1}.</div>
                      <div className="ques">{q.question}</div>
                    </div>

                    {/* <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        background: "#f1f5f9",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        color: "#334155",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {q?.max_marks} Marks
                    </div> */}
                  </h2>

                  {/* <p className="fz18 answer-text">
                    {q?.user_answer &&
                      q?.user_answer !== "NA" &&
                      q?.evaluation === "correct" && (
                        <>
                          <strong>Correct Answer:</strong>{" "}
                          {q?.correct_answer || "NA"}
                          <br />
                        </>
                      )}
                    <strong>Your Answer:</strong> {q?.user_answer || "NA"}
                  </p> */}

                  {/* {renderResultBox(q)} */}
                </div>
              );
            })}

            {/* Fill in the Blank */}
            {questionsListData?.fill_in_the_blank?.map((q, idx) => {
              const baseIndex = mcqCount + shortAnswerCount + idx;

              return (
                <div key={`fill-${idx}`} className="all-ans__content--item">
                  <h2
                    className="fz20 fw700"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div className="num">{baseIndex + 1}.</div>
                      <div className="ques">{q.question}</div>
                    </div>

                    {/* <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        background: "#f1f5f9",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        color: "#334155",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {q?.max_marks} Marks
                    </div> */}
                  </h2>

                  {/* <p className="fz18 answer-text">
                    {q?.user_answer &&
                      q?.user_answer !== "NA" &&
                      q?.evaluation === "correct" && (
                        <>
                          <strong>Correct Answer:</strong>{" "}
                          {q?.correct_answer || "NA"}
                          <br />
                        </>
                      )}
                    <strong>Your Answer:</strong> {q?.user_answer || "NA"}
                  </p> */}
                  {/* 
                  {renderResultBox(q)} */}
                </div>
              );
            })}
          </div>

          {/* <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
            <button
              type="button"
              className="btn btn-success px-4 py-2 fw-semibold shadow-sm"
              onClick={() => setOpenPopup(true)}
            >
              💡 Suggestions
            </button>
          </div> */}

          {/* <SuggestionPopup
            open={openPopup}
            onClose={() => setOpenPopup(false)}
            responseFromResult={responseFromResult || suggestionList}
          /> */}
        </div>
      </div>
    </main>
  );
};

export default ShowTestUnattempted;
